<div id="custom-snack-bar-container" [attr.data-test-id]="'custom-snack-bar'">
  <div class="custom-snack-bar-row">
    <span class="example-snack-bar-message">
      {{ data.message }}
    </span>
    <button id="action-button" (click)="dismissWithAction()" mat-icon-button [attr.data-test-id]="'custom-snack-bar_button_close'">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="flex flex-col mt-3">
  <div class="-ml-3 -mb-3">{{ data.duration.percent }}%</div>
  <mat-progress-bar id="progress-bar" mode="determinate" [value]="data.duration.percent"></mat-progress-bar>
</div>
</div>
